import { MobileCard } from '@/Components/shared/List/MobileCard';
import { VENDOR_TYPE_LABELS } from '../types/society.types';
import type { SocietyListItem } from '../types/society.types';
import { formatDateTimeAsUtc } from '../utils/dateFormat.utils';

interface SocietiesMobileCardsProps {
  data: SocietyListItem[];
  onRowClick?: (society: SocietyListItem) => void;
}

export function SocietiesMobileCards({ data, onRowClick }: SocietiesMobileCardsProps) {
  return (
    <div className="tw-space-y-3">
      {data.map((society) => (
        <MobileCard
          key={society.uuid}
          title={society.name}
          subtitle={society.rootParentName ? `Groupe: ${society.rootParentName}` : undefined}
          status={
            <span className={`tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-rounded-full ${society.isActive ? 'tw-bg-green-100 tw-text-green-800' : 'tw-bg-gray-100 tw-text-gray-800'}`}>
              {society.isActive ? 'Actif' : 'Inactif'}
            </span>
          }
          fields={[
            { label: 'Type', value: VENDOR_TYPE_LABELS[society.vendorType] },
            { label: 'Contrats', value: (society.contractsCount ?? 0).toLocaleString('fr-FR') },
            { label: 'Dernière connexion', value: formatDateTimeAsUtc(society.lastConnectionDate) },
          ]}
          onClick={onRowClick ? () => onRowClick(society) : undefined}
        />
      ))}
    </div>
  );
}
